import React, { FC } from 'react';
import { ProjectId } from 'api/models';
import { Option } from './types';
import { useOptions, UseOptionsResult } from './use-squad-options';

interface SquadOptionsProps {
  projectId: ProjectId;
  selected?: Option[];
  isPrivate?: boolean;
  canShowTeams?: boolean;
  children: (result: UseOptionsResult) => React.ReactNode;
}

export const SquadOptions: FC<SquadOptionsProps> = (props) => {
  const {
    projectId,
    children,
    isPrivate = false,
    selected = [],
    canShowTeams = true,
  } = props;
  const selectedValues = selected.map((s) => s.value);
  const result = useOptions(projectId, {
    isPrivate,
    selected: selectedValues,
    canShowTeams,
  });

  return <>{children(result)}</>;
};
